// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderTimeSelectionTimezoneTag_container__tuyzP","summer":"OrderTimeSelectionTimezoneTag_summer__lIv2m","standard":"OrderTimeSelectionTimezoneTag_standard__kZve9"};